import { computed } from "vue";
import { DataLayer } from "@allwyn/utils/data-layer";
import { useAuthentication } from "../composables/use-authentication";
import { AuthenticationState } from "../models/authentication-state";

export namespace AuthenticationAnalytics {
    const getAnalyticsAuthLocation = () => {
        const { currentState } = useAuthentication();

        switch (currentState.value) {
            case AuthenticationState.Login:
            case AuthenticationState.LoginOtp:
            case AuthenticationState.ForcedPasswordReset:
            case AuthenticationState.ForcedPasswordResetOtp:
                return "login";
            case AuthenticationState.ForgottenPassword:
            case AuthenticationState.PasswordReset:
            default:
                return "forgottenPassword";
        }
    };

    const analyticsAuthLocation = computed(getAnalyticsAuthLocation);

    export const pushLoginPopup = () => {
        DataLayer.push({
            page: {
                type: "account.login",
                kind: "widget.login",
                verticalCodeStrict: "no_vertical",
                gameCodeStrict: "no_game",
                pageviewType: "popup",
            },
            event: "page",
        });
    };

    export const pushLogin2FAPopup = () => {
        DataLayer.push({
            page: {
                type: "account.login",
                kind: "2FAwidget.login",
                verticalCodeStrict: "no_vertical",
                gameCodeStrict: "no_game",
                pageviewType: "popup",
            },
            event: "page",
        });
    };

    export const pushLoginSuccess = (playerId: string) => {
        DataLayer.push({
            event: "action.login.user",
            user: {
                id: playerId,
            },
            PID: playerId,
        });
    };

    export const pushLoginFailure = () => {
        DataLayer.push({
            event: "action.loginFailed.user",
        });
    };

    export const pushRegistrationClick = () => {
        DataLayer.pushInstant({
            event: "action.click.navigation",
            action: {
                click: {
                    name: "registration",
                    eventProperty1: `${analyticsAuthLocation.value}.popup`,
                    eventProperty2: `${analyticsAuthLocation.value}.popup`,
                },
            },
        });
    };

    export const pushChatClick = () => {
        DataLayer.pushInstant({
            event: "action.click.navigation",
            action: {
                click: {
                    name: "chat",
                    eventProperty1: `${analyticsAuthLocation.value}.popup`,
                    eventProperty2: `${analyticsAuthLocation.value}.popup`,
                },
            },
        });
    };

    export const pushHelpCenterClick = () => {
        DataLayer.pushInstant({
            event: "action.click.navigation",
            action: {
                click: {
                    name: "help center",
                    eventProperty1: `${analyticsAuthLocation.value}.popup`,
                    eventProperty2: `${analyticsAuthLocation.value}.popup`,
                },
            },
        });
    };

    export const pushForgottenPasswordSendCodeClick = () => {
        DataLayer.push({
            event: "action.click.button",
            action: {
                click: {
                    name: "forgottenPassword.sendCode",
                },
            },
        });
    };

    export const pushForgottenPasswordPopup = (headline: string) => {
        DataLayer.push({
            event: "action.impress.promos",
            action: {
                impress: {
                    promos: [
                        {
                            id: "forgottenPassword.login",
                            name: "forgottenPassword.login",
                            creative: headline,
                            position: "popup",
                        },
                    ],
                },
            },
        });
    };

    export const pushLogoutPopup = (headline: string) => {
        DataLayer.push({
            event: "action.impress.promos",
            action: {
                impress: {
                    promos: [
                        {
                            id: "logout",
                            name: "logout",
                            creative: headline,
                            position: "popup",
                        },
                    ],
                },
            },
        });
    };

    export const pushPlayerLimitedAccess = (text: string) => {
        // required by SazkaBet
        DataLayer.push({
            event: "action.impress.promos",
            action: {
                impress: {
                    promos: [
                        {
                            id: "error.pop-up",
                            name: "error",
                            creative: text,
                            position: "middle",
                        },
                    ],
                },
            },
        });
    };
}
